import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
var RevertIcon = function RevertIcon(_ref) {
  var onClick = _ref.onClick,
    style = _ref.style;
  return /*#__PURE__*/_jsx("svg", {
    "data-testid": "borne_revert_icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: Object.assign({
      height: 18,
      width: 18
    }, style),
    fill: "#666666",
    onClick: onClick,
    children: /*#__PURE__*/_jsx("path", {
      d: "M13,4.07V1L8.45,5.55L13,10V6.09C15.84,6.57 18,9.03 18,12C18,14.97 15.84,17.43 13,17.91V19.93C16.95,19.44 20,16.08 20,12C20,7.92 16.95,4.56 13,4.07M7.1,18.32C8.26,19.22 9.61,19.76 11,19.93V17.9C10.13,17.75 9.29,17.41 8.54,16.87L7.1,18.32M6.09,13H4.07C4.24,14.39 4.79,15.73 5.69,16.89L7.1,15.47C6.58,14.72 6.23,13.88 6.09,13M7.11,8.53L5.7,7.11C4.8,8.27 4.24,9.61 4.07,11H6.09C6.23,10.13 6.58,9.28 7.11,8.53Z"
    })
  });
};
RevertIcon.handledProps = ["onClick", "style"];
RevertIcon.propTypes = {
  onClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object
};
RevertIcon.defaultProps = {
  onClick: undefined,
  style: undefined
};
export default RevertIcon;